import $axios from '@/api/apiPublic';

const getGlossary = async (limit, offset) => {
  const response = await $axios.get(
    `glossary/list?limit=${limit}&offset=${offset}`,
  );
  return response;
};

const searchGlossary = async (language, word) => {
  const response = await $axios.get(
    `glossary/search?language=${language}&word=${word}`,
  );
  return response;
};

const getArticle = async id => {
  const response = await $axios.get(`glossary/${id}`);
  return response;
};

export default {
  getGlossary,
  searchGlossary,
  getArticle,
};
